import { Suspense } from 'react';
import AppRoutes from "./routes";
import "./App.css";

/**
 * Main App component that wraps the application
 * Uses Suspense for handling lazy-loaded components
 */
export default function App() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <AppRoutes />
    </Suspense>
  );
}